/**
 * Component / Customer: Form Listener.
 * ------------------------------------------------------------------------------
 * - Listen to Login/Register form submits and store submitted data.
 * - Used to track login/register submissions with Bloomreach and others.
 * - Loaded globally due to login form that appears in header.
 * @namespace CustomerFormListener
 */
import { storageNamespace } from '~/helpers/storage-namespaces'

/**
 * DOM selectors.
 */
const selectors = {
  headerLogin: 'form[id="header_form_login"]',
  login: 'form[id="customer_login"]',
  register: 'form[id="create_customer"]',
}

/**
 * Create a new customer form listener object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    forms: [
      ...document.querySelectorAll(selectors.headerLogin),
      ...document.querySelectorAll(selectors.login),
      ...document.querySelectorAll(selectors.register),
    ],
  }

  /**
   * Initialise component.
   */
  function init() {
    if (!nodeSelectors.forms || !mint.services?.bloomreach) {
      return
    }

    setEventListeners()
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    nodeSelectors.forms.forEach((form) => {

      /**
       * Don't prevent default, as sessionStorage is synchronous so
       * it won't block the original submit request.
       */
      form.addEventListener('submit', () => {
        storeFormFields(form)
      })
    })
  }

  /**
   * Store some form fields in the browser so that marketing
   * trackers can detect and track the data.
   * @param {HTMLElement} form - A given customer form
   */
  function storeFormFields(form) {
    const formType = form.id.split('_')[1]
    const formData = new FormData(form)
    const email = formData.get('customer[email]')
    const password = formData.get('customer[password]')

    if (!email) {
      return
    }

    const data = JSON.stringify({
      email,
      password,
      type: formType,
    })

    sessionStorage.setItem(storageNamespace.customerFormSubmit, data)
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
